import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';

class LodingSquareTabbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: '',
    };
  }

  componentDidMount() {
    this.syncActive();
  }

  componentDidUpdate() {
    this.syncActive();
  }

  syncActive() {
    if (!this.props.loading && this.props.list?.length && !this.props.list.includes(this.state.currentPage)) {
      this.setState({ currentPage: this.props.list[0] });
    }
  }

  handler = (item) => {
    this.setState({ currentPage: item });
    this.props.handler(item);
  };

  render() {
    return (
      <div className={this.props.classes}>
        <div>
          <nav className='-mb-px flex w-1/2' aria-label='Tabs'>
            {this.props.list.map((item) => {
              const isActive = this.state.currentPage === item;
              return this.props.loading ? (
                <div key={item} className='w-20 mr-2'>
                  <Skeleton width='100%' height={this.props.loaderHeight} />
                </div>
              ) : (
                <span
                  key={item}
                  onClick={() => this.handler(item)}
                  id={item}
                  className={`mr-1 rounded-ds-sm border py-2 px-4 text-xs font-semibold cursor-pointer transition-colors duration-150 ${
                    isActive
                      ? 'border-ds-brand bg-white text-ds-brand'
                      : 'border-gray-300 bg-gray-100 text-gray-700 hover:border-ds-brand hover:text-ds-brand'
                  }`}
                >
                  {item}
                </span>
              );
            })}
          </nav>
        </div>
      </div>
    );
  }
}

LodingSquareTabbar.defaultProps = {
  classes: '',
};

export default LodingSquareTabbar;
